import { from, lastValueFrom, map, switchMap } from "rxjs";
import { singleton } from "tsyringe";

import { AjaxApiCartApiService } from "../api_services/AjaxApiCartApiService/AjaxApiCartApiService";
import type CartEntity from "../entities/CartEntity";
import type { UpdateCartEntity } from "../entities/UpdateCartEntity";
import type { CartRepositoryInterface } from "./CartRepositoryInterface";

@singleton()
export class AjaxApiRepository implements CartRepositoryInterface {
    public constructor(
        private readonly ajaxApiCartApiService: AjaxApiCartApiService
    ) {}

    public async getCart(): Promise<{ cart: CartEntity }> {
        const cart = await lastValueFrom(this.ajaxApiCartApiService.getCart());
        return { cart };
    }

    public async addToCart(params: {
        items: {
            variantID: number;
            quantity: number;
            properties?: Record<string, string>;
        }[];
        sections?: string[];
    }): Promise<{
        cart: CartEntity;
        sections?: Record<string, string | null>;
    }> {
        const { cart, sections } = await lastValueFrom(
            this.ajaxApiCartApiService
                .addToCart({
                    items: params.items,
                    sections: params.sections || [],
                })
                .pipe(
                    switchMap((response) => {
                        return from(this.getCart()).pipe(
                            map(({ cart }) => {
                                return { cart, sections: response.sections };
                            })
                        );
                    })
                )
        );
        return {
            cart,
            sections,
        };
    }

    public async updateCart(params: {
        discount?: string;
        sections: string[];
    }): Promise<UpdateCartEntity> {
        return await lastValueFrom(
            this.ajaxApiCartApiService.updateCart(params)
        );
    }
}
